import React, { useEffect, useRef, useState } from 'react';
import ProgressCircle from '../ProgressCircle';
import SSButton from '../SSButton';
import PopUpContainer from '../PopUpContainer';
import './aitraining.scss';
import TrainingPopUp from '../TrainingPopUp';
import PersonalBG from '../../assets/personal-bg.png';
import ProfessionalBG from '../../assets/professional-bg.png';
import AITab from '../AITab';

export default function AITraining({ setTabStep, trainingValues, getProfile }) {
  const [openTrainingPopUp, setOpenTrainingPopUp] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [persDesc, setPersDesc] = useState('');
  const [companyDesc, setCompanyDesc] = useState('');
  const [getNewAiDetails, setGetNewAiDetails] = useState(false);
  const [isTrainAI, setIsTrainAI] = useState(false);
  const [showTabRefState, setShowTabRefState] = useState(false);
  const originalDescription = useRef('');
  const originalCompanyDescription = useRef('');

  useEffect(() => {
    if (trainingValues) {
      originalDescription.current = trainingValues?.description;
      originalCompanyDescription.current = trainingValues?.companyDescription;
      if (trainingValues?.overallProgress?.progress < 50) {
        setShowTabRefState(true);
      } else {
        setShowTabRefState(false);
      }

      if (trainingValues?.description) setPersDesc(trainingValues?.description);
      else setPersDesc('');
      if (trainingValues?.companyDescription) setCompanyDesc(trainingValues?.companyDescription);
      else setCompanyDesc('');
    }
  }, [trainingValues]);

  useEffect(() => {
    if (isTrainAI) {
      setOpenTrainingPopUp(true);
      setCurrentStep(1);
    }
  }, [isTrainAI]);

  const updateStyleBasedOnScore = (type, indicator) => {
    if (type === 'cls') {
      switch (indicator) {
        case 'LOW':
          return 'low';
        case 'MEDIUM':
          return 'med';
        default:
          return 'high';
      }
    } else {
      switch (indicator) {
        case 'LOW':
          return {
            color: '#FF0000',
          };
        case 'MEDIUM':
          return {
            color: 'rgba(255, 200, 7, 0.97)',
          };
        default:
          return {
            color: '#07FF5C',
          };
      }
    }
  };
  // const getAITrainingDetails = async () => {
  //   let url = `${DOMAIN}/v1/user/ai-training`;
  //   let requestHeaders = {
  //     authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
  //   };
  //   const agentsResponse = await getReq({
  //     url,
  //     requestHeaders,
  //   });
  //   const { code, data } = agentsResponse;
  //   let timeoutCode = code.toString();
  //   timeoutCode = Array.from(timeoutCode)[0];
  //   if (code === 200) {
  //     if (data?.description) setPersDesc(data?.description);
  //     else setPersDesc('');
  //     if (data?.companyDescription) setCompanyDesc(data?.companyDescription);
  //     else setCompanyDesc('');
  //     setGetNewAiDetails(false);
  //   } else if (timeoutCode === '5') {
  //     let newPayload = {
  //       ...profiles,
  //       code,
  //     };
  //     postLogger('GET_AI_TARINING_DETAILS', newPayload);
  //   }
  // };

  const handleAITabClick = () => {
    if (!showTabRefState) setTabStep(1);
    else {
      setIsTrainAI(true);
    }
  };

  if (trainingValues && trainingValues.overallProgress) {
    return (
      <div>
        <div className="ai-trainer">
          <div className="header">
            <ProgressCircle
              percentage={trainingValues?.overallProgress?.progress || 0}
              divStyle={`ai-progress ${updateStyleBasedOnScore('cls', trainingValues?.overallProgress?.indicator)}`}
            />
            <div className="training-scores">
              <h1 style={updateStyleBasedOnScore('', trainingValues?.overallProgress?.indicator)}>
                <span>Total Training Score: </span>
                {trainingValues?.overallProgress?.indicator || <span>Low</span>}
              </h1>
            </div>
            <AITab showTrainingTab={showTabRefState} handleAITabClick={handleAITabClick} />
          </div>
          <div className="training-types">
            <div className="training-types__item" style={{ backgroundImage: `url(${PersonalBG})` }}>
              <div className="training-types__item__progress">
                <ProgressCircle
                  percentage={trainingValues?.personalProgress?.progress || 0}
                  divStyle={`ai-progress ${updateStyleBasedOnScore(
                    'cls',
                    trainingValues?.personalProgress?.indicator
                  )}`}
                />
              </div>
              <div className="training-types__item__title">
                <h1>Personal Description Training</h1>
                <span>
                  AI uses personal description details to add personality on comments, posts, emails and other
                  communication streams.
                </span>
              </div>
              <SSButton
                type={trainingValues?.personalProgress?.progress === 0 ? 'filled' : 'outline'}
                btnText={trainingValues?.personalProgress?.progress === 0 ? 'TRAIN SECTION' : 'EDIT TRAINING'}
                onClickHandle={() => {
                  setCurrentStep(1);
                  setOpenTrainingPopUp(true);
                }}
              ></SSButton>
            </div>
            <div className="training-types__item" style={{ backgroundImage: `url(${ProfessionalBG})` }}>
              <div className="training-types__item__progress">
                <ProgressCircle
                  percentage={trainingValues?.professionalProgress?.progress || 0}
                  divStyle={`ai-progress ${updateStyleBasedOnScore(
                    'cls',
                    trainingValues?.professionalProgress?.indicator
                  )}`}
                />
              </div>
              <div className="training-types__item__title">
                <h1>Professional Description Training</h1>
                <span>
                  AI uses your Professional details to tailor communication towards your clients, and introduce
                  references of the product, service or company you are representing.
                </span>
              </div>
              <SSButton
                type={trainingValues?.professionalProgress?.progress === 0 ? 'filled' : 'outline'}
                btnText={trainingValues?.professionalProgress?.progress === 0 ? 'TRAIN SECTION' : 'EDIT TRAINING'}
                onClickHandle={() => {
                  setCurrentStep(2);
                  setOpenTrainingPopUp(true);
                }}
              ></SSButton>
            </div>
          </div>
        </div>
        {openTrainingPopUp && (
          <PopUpContainer>
            <TrainingPopUp
              trainingStep={currentStep}
              setOpenTrainingPopUp={setOpenTrainingPopUp}
              persDesc={persDesc}
              setPersDesc={setPersDesc}
              companyDesc={companyDesc}
              setCompanyDesc={setCompanyDesc}
              setGetNewAiDetails={setGetNewAiDetails}
              isTrainAI={isTrainAI}
              setIsTrainAI={setIsTrainAI}
              getProfile={getProfile}
              originalDescription={originalDescription.current}
              originalCompanyDescription={originalCompanyDescription.current}
            ></TrainingPopUp>
          </PopUpContainer>
        )}
      </div>
    );
  }
}
